export const formStatusLabels = ["In Progress", "IRS Rejected", "Ready to Submit", "Submitted"];

export const recipientStatusLabels = ['Unverified', 'Request W8/W9', 'Verified', 'Submitted'];

export const statusColors = ['#F6CF45', '#6DB1FF', '#F6A458', '#76CC95'];

